import type { IconComponent } from '@consta/icons/Icon'
import { Button } from '@consta/uikit/Button'
import { Responses } from '@consta/uikit/Responses'
import { ResponsesImageNothingFound } from '@consta/uikit/ResponsesImageNothingFound'
import { Text } from '@consta/uikit/Text'
import type { FC, MouseEventHandler } from 'react'

import css from './NotFound.css'

type NotFoundProps = {
  title?: string
  description: string
  actionLabel?: string
  remoteActionId?: string
  actionIcon?: IconComponent
  onActionClick?: MouseEventHandler
}

const NotFound: FC<NotFoundProps> = ({
  title,
  description,
  actionLabel,
  remoteActionId,
  actionIcon,
  onActionClick,
}) => {
  const hasAction = actionLabel != null || remoteActionId != null
  const hasTitle = title != null

  return (
    <Responses
      className={css.notFound}
      size="m"
      title={
        !!hasTitle && (
          <Text view="primary" size="m">
            {title}
          </Text>
        )
      }
      image={ResponsesImageNothingFound}
      description={
        <Text as="span" size="s" view="secondary">
          {description}
        </Text>
      }
      actions={
        !!hasAction && (
          <label htmlFor={remoteActionId}>
            <Button
              as="div"
              className={css.removeMarginTop}
              label={actionLabel}
              iconLeft={actionIcon}
              iconSize="xs"
              size="xs"
              view="ghost"
              onClick={onActionClick}
            />
          </label>
        )
      }
    />
  )
}

export const createNotFound = (
  displayName: string,
  props: Omit<NotFoundProps, 'onActionClick'>,
) => {
  const SpecificNotFound: FC<Pick<NotFoundProps, 'onActionClick'>> = ({ onActionClick }) => {
    return <NotFound {...props} onActionClick={onActionClick} />
  }

  SpecificNotFound.displayName = displayName

  return SpecificNotFound
}
